import { defineStore } from 'pinia';
import { ref } from 'vue';
import { editDataApi } from '@/api/storageTracking/EditDataApi.ts';
import { IDataValidations } from '@/interfaces/storageTracking/IDataValidations.ts';
import { useAreaDataStore } from './AreaDataStore.ts';

export const UseDataValidationStore = defineStore('dataValidationStore', () => {
    const areaDataStore = useAreaDataStore();

    const countryCodes: string[] = [
        ...areaDataStore.countries
            .filter(c => !c.hidden)
            .map(c => c.value),
        'GB-NIR',
    ];

    const segments = [
        'Front-of-meter',
        'Commercial and industrial (C&I)',
        'Residential',
    ];

    const statuses = ref<Array<string>>([]);
    const technologies = ref<Array<string>>([]);
    const companies = ref<Array<string>>([]);
    const installations = ref<Array<string>>([]);

    async function initialise (): Promise<void> {
        const vals: IDataValidations = await editDataApi.getDataValidations();
        companies.value = [...vals.companies].sort((a, b) => a.localeCompare(b));
        statuses.value = [...vals.statuses].sort((a, b) => a.localeCompare(b));
        technologies.value = [...vals.technologies];
        installations.value = [...vals.installations];
    }

    initialise();

    return {
        companies,
        countryCodes,
        installations,
        segments,
        statuses,
        technologies,
    };
});
